import React, {useContext, useEffect} from 'react';
import {AdminRole, DetTunerAdminRole} from '../../../model/constants'
import { UsersContext } from '../../../context/users-context';
import { DetTunersContext } from '../../../context/dettuners-context';
import * as DetTunerWorker from '../../../workers/detTunerWorker'
import TableComponent from '../TableComponent'
import { Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@material-ui/core';
import {parseLocalString} from '../../../utilities/utils';

export default function DetTunerTable(props) {
  console.log("render DetTunerTable");

  const [usersState] = useContext(UsersContext);
  const [detTunersState, detTunersDispatch] = useContext(DetTunersContext);

  const [error, setError] = React.useState("");

  const isAdmin = usersState.currentUser?.Role === AdminRole;
  const isTunerAdmin = isAdmin || usersState.currentUser?.Role === DetTunerAdminRole;

  const getTuners = () => Object.assign({}, ...detTunersState.tuners.map(t => ({[t.TunerId]: t.TunerId})));

  const columns = [
    { field: 'DetectorType', title: 'Тип детектора', sortable: true,  validate: rowData => !!rowData.DetectorType },
    { field: 'MACAddress', title: 'MAC адрес', validate: rowData => !!rowData.MACAddress },
    { field: 'SerialNumber', title: 'Серийный номер', validate: rowData => !!rowData.SerialNumber },
    { field: 'SensorSN', title: 'Сенсор S/N', validate: rowData => !!rowData.SensorSN },
    { field: 'PanelId', title: 'ID Панели' },
    { field: 'DetectorId', title: 'ID детектора' },
    { field: 'DetectorVersion', title: 'Версия детектора' },
    { field: 'XD_main_uid', title: 'UidMain' },
    { field: 'XD_main_hash', title: 'VersionMain' },
    { field: 'XD_readout_uid', title: 'UidReadout' },
    { field: 'XD_readout_hash', title: 'VersionReadout' },
    { field: 'XD_scanner_uid', title: 'UidScanner' },
    { field: 'XD_scanner_hash', title: 'VersionScanner' },
    { field: 'LastCalibrationDate', title: 'Дата калибровки', editable: 'never', sorting: false, type: 'datetime', dateSetting: { locale: navigator.language } },
    { field: 'DetTunerId', title: 'Тюнер', lookup: getTuners() },
    { field: 'Comment', title: 'Примечания', align: 'left',
      render: (rowData) => ((rowData.Comment + '').split('\n').map((item, key) => (<span key={key}>{item}<br/></span>))), 
      editComponent: ({ value, onChange }) => (<TextField onChange={e => onChange(e.target.value)} value={value} multiline/>) },
  ];

  const detailColumns = [
    { field: 'ShotType' },
    { field: 'Name' },
    { field: 'CalibrationDate', type: 'datetime', dateSetting: { locale: navigator.language }, initialEditValue: (new Date()).toJSON()  },
  ];

  const showError = (msg) => {
    setError(msg);
  }

  const onAdd = async (newData) => {
    let data = await DetTunerWorker.AddDetector(usersState.token, newData);
    if (data === undefined)
      return;
    if (data.error)
      showError(data.error);
    else
      detTunersDispatch({ type: 'UPDATEDETECTOR', payload: data});
  };
  
  const onEdit = async (newData) => {
    let data = await DetTunerWorker.UpdateDetector(usersState.token, newData);
    if (data === undefined)
      return;
    if (data.error)
      showError(data.error);
    else
      detTunersDispatch({ type: 'UPDATEDETECTOR', payload: data});
  };
  
  const onDelete = async (oldData) => {
    let res = await DetTunerWorker.DeleteDetector(usersState.token, oldData.ID);
    if (res !== undefined)
      detTunersDispatch({ type: 'DELETEDETECTOR', payload: oldData.ID});
  };
  
  const onDetail = [
    {
      tooltip: 'История калибровок',
      render: (rowData) => (<DetailTable columns={detailColumns} parent={rowData}/>)
    },
  ];

  const DetailTable = (props) => {
    const columns = props.columns;
    const parent = props.parent;
    var [data, setData] = React.useState([]);
  
    const getData = async () => {
      const calibrations = await DetTunerWorker.GetCalibrations(usersState.token, parent.ID);
      if (calibrations !== undefined)
        setData(calibrations);
    }
  
    useEffect(() => {
      getData();
    }, [])
  
    return (
      <TableContainer style={{maxHeight: 200}}>
        <Table size='small'>
          <TableBody>{
            data.map((row,rowInd) => { return (
              <TableRow key={`row_${rowInd}`}>{
                columns.map((column) => { 
                  let value = row[column.field];
                  if (column.type === 'datetime')
                    value = parseLocalString(value);
                  return (
                  <TableCell key={`cell_${rowInd}_${column.field}`}>{value}</TableCell>
                )})}
              </TableRow>
            )})}
          </TableBody>
        </Table>
      </TableContainer>
    )
  }

  return (
      <TableComponent
        columns={columns}
        data={props.data}
        canEdit={isTunerAdmin}
        options={{
          search: true
        }}
        onRowAdd={onAdd}
        onRowUpdate={onEdit}
        onRowDelete={onDelete}
        detailPanel={onDetail}
        errorMsg={error}/>
  );
}